<template>
    <div class="about">
        <div class="flex__center__center column wrap">
            <p class="title">ABOUT US</p>
            <div class="flex__center__center">
                <span>——&emsp;</span>
                <span class="fs_38 c_1a">{{infos.title}}</span>
                <span>&emsp;——</span>
            </div>
        </div>
        <div class="mt_40" v-html="infos.content">{{infos.content}}</div>
    </div>
</template>
<script>
export default {
    name: "About",
    data(){
        return{
            infos:{
            }
        }
    },
    methods:{
        link(){
            window.location.href=this.infos.carousel[0].url;
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Vip/aboutUs').then(
            res=>{
                if(res.data.code==1){
                    this.infos=res.data.data;
                }
            }
        )
    }

}
</script>
<style scoped>
.about{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    padding: 0 45px 30px;
    background: #fff;
    overflow: auto;
}
.title{
    font-size: 70px;
    color: #e6e6e6;
    line-height: 90px;
    font-weight:normal;
}
</style>



// WEBPACK FOOTER //
// src/pages/mine/About.vue